import { motion } from "framer-motion";
import { IMAGES, INSTAGRAM_URL } from "../constants/site";

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative overflow-hidden pt-40 pb-24 lg:pt-52 lg:pb-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-6">
          <motion.p
            variants={fadeUp}
            initial="hidden"
            animate="visible"
            custom={0}
            className="mb-8 text-xs uppercase tracking-[0.35em] text-[#C8A88B]"
          >
            Lash Extensions &amp; Lash Lifts
          </motion.p>
          <motion.h1
            variants={fadeUp}
            initial="hidden"
            animate="visible"
            custom={1}
            className="font-serif-display text-6xl font-light leading-[0.95] tracking-tight text-[#E6D5C3] sm:text-7xl lg:text-8xl"
          >
            Feel pretty,
            <br />
            <em className="text-[#C8A88B]">look expensive.</em>
          </motion.h1>
          <motion.p
            variants={fadeUp}
            initial="hidden"
            animate="visible"
            custom={2}
            className="mt-10 max-w-md text-base font-light leading-relaxed text-[#A89B8F]"
          >
            Signature lash styles with a clean aesthetic. Haus of Lash is a studio
            built on detail — every set tailored to your eyes, your look, your life.
          </motion.p>
          <motion.div
            variants={fadeUp}
            initial="hidden"
            animate="visible"
            custom={3}
            className="mt-12 flex flex-wrap items-center gap-6"
          >
            <a
              data-testid="hero-enquire-button"
              href="#enquire"
              className="bg-[#E6D5C3] px-8 py-4 text-xs uppercase tracking-[0.2em] text-[#130F0D] transition-colors duration-200 hover:bg-[#DEBFA2]"
            >
              Book an Inquiry
            </a>
            <a
              data-testid="hero-instagram-link"
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs uppercase tracking-[0.2em] text-[#A89B8F] underline underline-offset-8 transition-colors duration-200 hover:text-[#E6D5C3]"
            >
              Follow the journey
            </a>
          </motion.div>
        </div>
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="relative lg:col-span-6"
        >
          <div className="absolute -left-6 -top-6 h-full w-full border border-[#332A24]" aria-hidden="true" />
          <div className="relative overflow-hidden">
            <img
              src={IMAGES.hero}
              alt="Volume lash set by Haus of Lash"
              data-testid="hero-image"
              className="aspect-square w-full object-cover"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export const Ticker = () => {
  const items = ["Lash Extensions", "Lash Lifts", "Signature Sets", "Haus of Lash"];
  const row = [...items, ...items];
  return (
    <div data-testid="ticker-strip" className="overflow-hidden border-y border-[#332A24] py-5" aria-hidden="true">
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="mx-8 font-serif-display text-2xl font-light italic text-[#A89B8F]"
              >
                {item}
                <span className="ml-16 not-italic text-[#332A24]">·</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
